import { isHotel } from 'lib/offer/offerTypes'
import { useAppSelector } from 'hooks/reduxHooks'
import { getAllOffers } from 'selectors/offerSelectors'

export default function useOffersWithProperty(
  offerIds: Array<string>,
  targetPropertyId: string | undefined,
): App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary | undefined {
  const allOffers = useAppSelector(getAllOffers)

  if (!targetPropertyId) return

  const formattedPropertyId = Array.isArray(targetPropertyId) ? (targetPropertyId[0] as string) : targetPropertyId

  for (const offerId of offerIds) {
    const offer: App.AnyOffer = allOffers[offerId]
    if (offer && isHotel(offer) && offer.property.id === formattedPropertyId) {
      return offer
    }
  }
}
